import * as actions from '../../redux/actions';

import React, { useState } from 'react';

import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';
import GoogleMapReact from 'google-map-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const UnderLine = () => {
	return (
		<div
			style={{
				width: '130px',
				height: '2px',
				backgroundColor: '#ff6219',
				// marginTop: '0.50rem !important',
				marginTop: 5,
			}}
		></div>
	);
};

const expresoNorteOffices = [
	{
		city: 'Metropolitana',
		offices: [
			{
				officeName: 'CASA MATRIZ',
				address: 'Eduardo Frei Montalva N° 1371',
				officeNumber: '+562 -2596 1100',
			},
			{
				officeName: 'SAN BORJA',
				address: 'San Borja N° 184',
				officeNumber: 'Oficina 47 (2 – 2596 6496) - Oficina 62 (2 – 2596 6494)',
			},
			{
				officeName: 'INDEPENDENCIA',
				address: 'Eduardo Frei Montalva N° 1371',
				officeNumber: '(9 - 6424 3801)',
			},
		],
		latitude: '-33.456130',
		longitude: '-70.688390',
	},
	{
		city: 'Arica y Parinacota',
		offices: [
			{
				officeName: 'ARICA',
				address: 'Diego Portales N° 948',
				officeNumber: 'Oficina 12 (58 – 224 1587) - Oficina 15 (58 – 224 3998)',
			},
		],
	},
	{
		city: 'de Tarapacá',
		offices: [
			{
				officeName: 'IQUIQUE (TERMINAL)',
				address: 'Patricio Lynch s/n, Terminal Rodoviario, Of. 17',
				officeNumber: '(57 – 242 1135)',
			},
			{
				officeName: 'IQUIQUE (MERCADO)',
				address: 'Barros Arana N° 881',
				officeNumber: '(57 – 242 3215)',
			},
		],
	},
	{
		city: 'de Antofagasta',
		offices: [
			{
				officeName: 'ANTOFAGASTA',
				address: 'Pedro Aguirre Cerda N° 5750',
				officeNumber: '(55 – 255 2229)',
			},
			{
				officeName: 'ANTOFAGASTA',
				address: 'Paraguay N° 846',
				officeNumber: '(55 – 256 9338)',
			},
			{
				officeName: 'ANTOFAGASTA',
				address: 'Latorre N° 30376',
				officeNumber: '(55 – 256 9806)',
			},
			{
				officeName: 'CALAMA',
				address: 'Balmaceda N° 1902',
				officeNumber: '(55 – 255 6845)',
			},
			{
				officeName: 'CALAMA',
				address: 'Topain N° 2102',
				officeNumber: '(55 – 259 2569)',
			},
			{
				officeName: 'CALAMA',
				address: 'Santa María N° 1931',
				officeNumber: '(55 – 256 6345)',
			},
			{
				officeName: 'SIERRA GORDA',
				address: 'Salvador Allende N° 409',
				officeNumber: 'Salvador Allende N° 409',
			},
		],
	},
	{
		city: 'de Atacama',
		offices: [
			{
				officeName: 'CALDERA',
				address: 'Ossa – Varas Carvallo esq. Cifuentes S/N',
				officeNumber: '(52 – 231 6091)',
			},
			{
				officeName: 'CHAÑARAL',
				address: 'Merino Jarpa N° 805',
				officeNumber: '(52 – 252 0015)',
			},
			{
				officeName: 'COPIAPÓ',
				address: 'Chañarcillo N° 655',
				officeNumber: '(52 – 223 1176)',
			},
			{
				officeName: 'VALLENAR',
				address: 'Arturo Prat N° 137 Oficina 2-3',
				officeNumber: '(51 – 254 6677)',
			},
		],
	},
	{
		city: 'de Coquimbo',
		offices: [
			{
				officeName: 'ANDACOLLO',
				address: 'Urmeneta N° 658',
				officeNumber: '(51 – 254 3550)',
			},
			{
				officeName: 'COQUIMBO',
				address: 'Varela N° 1300, Oficina 9',
				officeNumber: '(51 – 254 6893) - (51 – 254 6894)',
			},
			{
				officeName: 'COQUIMBO',
				address: 'Baquedano N° 1007',
				officeNumber: '(51 – 232 0192)',
			},
			{
				officeName: 'ILLAPEL',
				address: 'San Martín N° 260, Oficina 4',
				officeNumber: '(53 – 252 2651)',
			},
			{
				officeName: 'LA SERENA',
				address: 'Amunátegui esq. El Santo, Oficina A5',
				officeNumber: '(51 – 254 6886)',
			},
			{
				officeName: 'LOS VILOS',
				address: 'Caupolicán N° 714',
				officeNumber: '(53 – 244 8306)',
			},
			{
				officeName: 'OVALLE',
				address: 'Ariztía Oriente N° 769',
				officeNumber: 'Oficina 13-14 (53 – 263 1593) - Oficina 2 (53 – 262 0430)',
			},
			{
				officeName: 'PICHIDANGUI',
				address: 'Del Mastelero Manzana B Of. 16',
				officeNumber: '(9 – 5091 6746)',
			},
			{
				officeName: 'SALAMANCA',
				address: 'Bernardo O’Higgins N° 500',
				officeNumber: '(53 – 244 8298)',
			},
			{
				officeName: 'VICUÑA',
				address: 'Bernardo O’Higgins esq. Arturo Prat, Oficina 7',
				officeNumber: '(51 – 254 6890)',
			},
		],
	},
	{
		city: 'Valparaíso',
		offices: [
			{
				officeName: 'LA CALERA',
				address: 'Avda. Gonzalo Lizasoain N° 399-431, Oficina 8',
				officeNumber: '(33 – 222 1833)',
			},
			{
				officeName: 'LIMACHE',
				address: 'Condell N° 416',
				officeNumber: '(33 – 241 3433)',
			},
			{
				officeName: 'SAN FELIPE',
				address: 'Avenida Yungay N° 300',
				officeNumber: '(34 – 234 5733)',
			},
			{
				officeName: 'VALPARAÍSO',
				address: 'Avda. Pedro Montt 2860',
				officeNumber: 'Oficina 12-B (32 – 221 0704) - Oficina 21 (32 – 225 8986)',
			},
			{
				officeName: 'VIÑA DEL MAR',
				address: 'Av. Valparaíso N° 1055',
				officeNumber: 'Oficinas 26 – 27 - (32 – 254 3676)',
			},
		],
	},
];

export const OfficesList = ({ officeLocations, smallHeading, boldHeading, image, operator }) => {
	const isExpresoNorto = operator.operator_name === 'expressonorte';

	const [selectedOffice, setSelectedOffice] = useState(
		isExpresoNorto ? expresoNorteOffices[0] : officeLocations[0],
	);

	const officeData = isExpresoNorto ? expresoNorteOffices : officeLocations;

	// const createMarkup = data => {
	//   return { __html: data };
	// };

	return (
		<div className="themes-offices">
			{isExpresoNorto && (
				<style>
					.offices {'{'}
					border: 1px solid #ddd; border-bottom-left-radius: 15px; border-bottom-right-radius: 15px;
					overflow: hidden;
					{'}'}
					.office__list {'{'}
					padding-top: 0 !important;
					{'}'}
					.offices .office__list .office__item {'{'}
					background-color: #f4f4f4 !important; color:#464647; border: 1px solid #ccc
					{'}'}
					.offices .office__list .selected-location {'{'}
					background-color:{' '}
					{operator && operator.color_codes ? operator.color_codes.primary_color : ''} !important;
					color: #fff
					{'}'}
					.offices .office__list .selected-location .office__name {'{'}
					border-bottom: 2px solid #fff !important
					{'}'}
					.offices .office__list .office__item .office__name {'{'}
					text-align:center; border-bottom: 2px solid #ff6219
					{'}'}
					.offices .office__map .office__map-details .selected-location-name {'{'}
					border-bottom: 2px solid #ff6219;
					{'}'}
					.offices .office__map {'{'}
					background-color: #fff;
					{'}'}
				</style>
			)}
			<div className="new-container" style={{ marginTop: 40 }}>
				<h2 className="capitalize font10 less-bold-text mb5">{smallHeading}</h2>
				<h1 className="capitalize font13 bold-text mb5 black-text-color">{boldHeading}</h1>
				<div className="offices">
					<ul className="office__list">
						{officeData.map((item, index) => (
							<li
								onClick={() => setSelectedOffice(item)}
								className={`
                                        cursor-pointer
                                        office__item
                                        ${isExpresoNorto
										? ''
										: index % 2 === 0
											? 'background-light-green'
											: 'background-dark-green'
									}
                                        ${item.city === selectedOffice.city && 'selected-location'}
                                   `}
							>
								<span className="office__name font11">{item.city}</span>
							</li>
							// </>
						))}
					</ul>
					<div className="office__map">
						<div className="office__map-view">
							{image ? (
								<img src={image} className="about-service-image" />
							) : (
								<GoogleMapReact
									key="marker_1"
									bootstrapURLKeys={{ key: AppData.MAP_API_KEY }}
									defaultCenter={{
										lat: parseFloat(
											selectedOffice && selectedOffice.latitude ? selectedOffice.latitude : 0,
										),
										lng: parseFloat(
											selectedOffice && selectedOffice.longitude ? selectedOffice.longitude : 0,
										),
									}}
									defaultZoom={11}
								></GoogleMapReact>
							)}
						</div>
						<div
							className="office__map-details "
							style={
								isExpresoNorto
									? {
										padding: '20px 30px',
										justifyContent: 'flex-start',
										alignItems: 'flex-start',
										width: '60%',
										overflowY: 'scroll',
									}
									: {}
							}
						>
							<div className="office__map-details-text">
								{!image ? (
									isExpresoNorto ? (
										selectedOffice.offices.map((item, i) => (
											<div className="mt-2 mb-3">
												<div className="d-flex align-items-center w-100">
													<span
														className="selected-location-name d-inline-block pb-0 pr-1 mb-0 font10 bold-text"
														style={{ borderBottom: 'none', width: 'auto', marginTop: '3px' }}
													>
														{item.officeName}
													</span>
													<img
														src={getIcons('OfficeTicketIcon', operator)}
														style={{ height: '20px', width: 'auto' }}
														alt=""
													/>
												</div>
												<UnderLine />
												<div className="mt-2">
													<div className="d-flex align-items-center mb-1">
														<img
															src={getIcons('OfficeLocationIcon', operator)}
															style={{ width: '15px' }}
															alt=""
														/>
														<span className="d-flex flex-column font10 pl-2">
															{item.officeNumber}
														</span>
													</div>
													<div>
														<img
															src={getIcons('OfficePhoneIcon', operator)}
															style={{ width: '15px' }}
															alt=""
														/>
														<span className="selected-location-contact-no mb-0 pl-2">
															{item.address}
														</span>
													</div>
												</div>
											</div>
										))
									) : (
										<React.Fragment>
											<span className="selected-location-name">{selectedOffice.city}</span>
											<div>
												<span className="selected-location-contact-no">{selectedOffice.phone}</span>
												<br />
												<span className="selected-location-address">{selectedOffice.address}</span>
											</div>
										</React.Fragment>
									)
								) : (
									<OperatorServices operator={operator} selectedOffice={selectedOffice} />
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const OperatorServices = ({ operator, selectedOffice }) => {
	return (
		<div>
			<span className="selected-location-name">{selectedOffice.title}</span>
			<div className="service-item lh-1-3">
				{selectedOffice.features.map((val, i) => {
					return (
						<div className="features">
							<span
								style={{
									height: 2,
									width: 10,
									display: 'flex',
									backgroundColor:
										operator && operator.color_codes && operator.color_codes.secondary_color
											? operator.color_codes.secondary_color
											: '',
									marginRight: 5,
								}}
							></span>
							<span>{val.label}</span>
						</div>
					);
				})}
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(OfficesList);



// WEBPACK FOOTER //
// ./src/features/themes/common/OfficeList/OfficesList.js